import { render, staticRenderFns } from "./ContractsSidebar.vue?vue&type=template&id=f2342c6a&"
import script from "./ContractsSidebar.vue?vue&type=script&lang=js&"
export * from "./ContractsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContractsSidebar.vue"
export default component.exports